import { SERVICE_OGP_IMAGE, SITE_URL } from '../../constants'
import { buildCasesIndexSchema } from '../../builders/casesIndex'
import { casesIndexItems } from '../../data/casesIndexItems'
import { PageMeta } from '../../types'

const description =
  '金融・不動産・IT・製造・小売・公共など多業界にわたるAitria（アイトリア）の支援実績を掲載。スマホアプリ開発、UX/UI改善、クラウドネイティブ、AI導入、デザインシステム構築など、サービス・業界別に事例を検索できます。'

export const casesIndexPageMeta: PageMeta = {
  title: '支援実績・開発事例一覧 | アプリ開発・UX/UI改善・AI導入 | Aitria（アイトリア）',
  description,
  keyword:
    '事例 実績 クラウドネイティブ AI駆動開発 デザインシステム UX/UIデザイン モダンスタック CI/CD DevOps AIエージェント',
  image: SERVICE_OGP_IMAGE,
  url: `${SITE_URL}/cases/`,
}

export const casesIndexSchema = buildCasesIndexSchema({
  pageTitle: casesIndexPageMeta.title,
  description: casesIndexPageMeta.description,
  listName: 'Aitria プロジェクト事例一覧',
  listDescription: 'クラウドネイティブ、AI駆動開発、デザインシステムなどの支援実績',
  items: casesIndexItems,
})
